<template>
	<div class="advisory-banner">
		<table>
			<tr>
				<td class="">

						<div style="margin-bottom:0px;padding-top:10px;" id="topbanner">
							<p style="text-align: center;"><u>Upcoming Spring 2027 Application Deadlines:</u></p>

<!--							<p style="text-align: center;">MSW in Social Work (Women) - Oct. 14, 2026</p>-->
<!--							<p style="text-align: center;">MSW in Social Work (Men) - Oct. 21, 2026</p>-->

						</div>
				<div style="padding:10px;">

<!--											<p style="text-align: center;"><u>Fall 2026 LATE Application Deadlines:	</u></p>-->

													<div class="container-banner " >
																	<div class="column">

																			<p>BA in Psychology (All Tracks) - December 1 , 2026										</p>
																				<p>Bachelor’s in Accounting - December 1 , 2026</p>

																						<p>	Bachelor’s in Business - December 1 , 2026		</p>

																							<p>Bachelor’s in Legal Studies - December 1 , 2026	</p>




																		</div>
											<div class="column">

												<p>Master’s/Adv. Certificate in ABA - December 1 , 2026</p>

												<p>Master’s in Accounting (Men) - December 1 , 2026</p>
												<p>Master’s in Education - December 1 , 2026	</p>

												<p>SLP/ Medical/ Nutrition/ OT Prerequisites  - December 1 , 2026	</p>

										</div>


														</div>


				</div>
					<div >
						<p style="text-align: center;"><u>Upcoming Fall 2027 Application Deadlines:</u></p>

						<p style="text-align: center;">Doctorate in Counseling Psychology (PsyD) - Dec. 1, 2026
						</p>


					</div>


				</td>
			</tr>

		</table>
	</div>
</template>

<script>

export default {
	name: "AdvisoryBanner",

	data() {
		return {};
	},
	computed: {
		lateDate() {
			const targetDateET = '2024-12-11T04:01:00Z'; // is 7/23 after 11:59
			const nowLocal = new Date();
		const targetDate = new Date(targetDateET);
			return nowLocal > targetDate;

		},

	},


};
</script>
<style scoped>
.advisory-banner {
	color: white;
	background-color: #3ba6e9;
	border-color: #6f6e6e;
	font-size: 15px;
	padding: 10px 5px;
	text-align: center;
}

.advisory-banner table {
	width: 55%;
	margin: auto;
	text-align: left;
	color: white;
	line-height: 1.3;
}

.advisory-banner table td {
	padding: 0;
	padding-left: 10px;
}

.advisory-banner table p {
	margin-top: 0.2em;
	margin-bottom: 0.2em;
}
#listDeadlines  {

	column-count: 2;
	column-gap: 20px;
}
#listDeadlines li {
	list-style-type: none;
	padding-left: 0;
//display: inline-block;

}
#topbanner {
	text-align: center; width: 100%;margin-bottom:-30px;
}
.container-banner {
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
}
.second-box {
	margin-top: -20px;
}

.column {
	flex: 1;
	min-width: 200px;
	padding: 20px;

}

.advisory-banner > table,
td,
tr {
	border: 1px white solid;
}
@media screen and (max-width: 1350px) {
	.advisory-banner table {
		width: 82%;

	}
}
@media screen and (max-width: 991px) {
	.advisory-banner table {
		width: 100%;

	}
	#topbanner {
	margin-bottom:0px;
	}
	#listDeadlines {
		column-count: 1;
		padding-left:10px;

	}
	.container {
		flex-direction: column;
	}
	.container-banner {
		gap: 0;
	}
	}

</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/AdvisoryBanner.vue